const dk = {
  translation: {
    salutation: "hej der",
    introduction: "jeg er",
    introudction_job_title: "og jeg er en",
    developer: "udvikler",
    download: "download",
    cv: "CV",
    select: "vælg",
    experiance_years: "{{years}} år",
    of_experiance: "erfaring",
    my_portofolio: "mit portefølje",
    portofolio: "portefølje",
    testimonials: "anbefalinger",
    all: "alle",
    about: "om",
    skill_level_question: "hvad er mit færdighedsniveau",
    see_more: "se mere",
    achievements: "resultater",
    personal_info: "personlig information",
    experience: "erfaring",
    education: "uddannelse",
    skills_and_technology: "færdigheder og teknologi",
    hide: "skjul",
    get_in_touch: "kom i kontakt",
    send_message: "send besked",
    message: "besked",
    subject: "emne",
    your_name: "dit navn",
    email_address: "email adresse",
    talk_statment: "lad os tale om alt",
    like_form_question: "kan ikke lide formularer",
    send_me: "send mig en",
    email: "email",
    language: "sprog",
    home_page: "hjemmeside",
    me: "mig",
    my_experience: "min erfaring",
    coming_soon: "kommer snart",
    this_page_is_under_construction: "denne side er under opbygning",
    is_required_field: "{{field}} er et påkrævet felt",
  },
};

export default dk;
